<template>
    <div class="policy">
        <h1>{{privacyAgreement.chineseTitle}}</h1>
        <div v-html="privacyAgreement.imageContent"></div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
    name: 'policy',
    data() {
        return {
            privacyAgreement: ''
        }
    },
    created() {
        this.getJurisdictionInfo()
    },
    methods: {
		getJurisdictionInfo() {
			const API = Baseurl + 'guanwangManageController/getJurisdictionInfo'
			const paramsData = {
				id: 78
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.data.code === 200) {
						this.privacyAgreement = res.data.data.guanwangImages[1]
					}
				})
		},
    }
}
</script>
<style lang="scss" scoped>
.policy {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    div{
        width: 50%;
    }
}
</style>